var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDateCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-calendar-check-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 2.33317H15.3084V1.49984C15.3084 1.27882 15.2206 1.06686 15.0643 0.910582C14.9081 0.754301 14.6961 0.666504 14.4751 0.666504C14.2541 0.666504 14.0421 0.754301 13.8858 0.910582C13.7295 1.06686 13.6417 1.27882 13.6417 1.49984V2.33317H6.85841V1.49984C6.85841 1.27882 6.77062 1.06686 6.61434 0.910582C6.45806 0.754301 6.2461 0.666504 6.02508 0.666504C5.80407 0.666504 5.59211 0.754301 5.43583 0.910582C5.27955 1.06686 5.19175 1.27882 5.19175 1.49984V2.33317H3.83341C3.39139 2.33317 2.96746 2.50877 2.6549 2.82133C2.34234 3.13389 2.16675 3.55781 2.16675 3.99984V16.8332C2.16675 17.2752 2.34234 17.6991 2.6549 18.0117C2.96746 18.3242 3.39139 18.4998 3.83341 18.4998H16.6667C17.1088 18.4998 17.5327 18.3242 17.8453 18.0117C18.1578 17.6991 18.3334 17.2752 18.3334 16.8332V3.99984C18.3334 3.55781 18.1578 3.13389 17.8453 2.82133C17.5327 2.50877 17.1088 2.33317 16.6667 2.33317ZM9.58329 11.9998C9.2151 11.9998 8.91663 12.2983 8.91663 12.6665C8.91663 13.0347 9.2151 13.3332 9.58329 13.3332H12.25C12.6181 13.3332 12.9166 13.0347 12.9166 12.6665C12.9166 12.2983 12.6181 11.9998 12.25 11.9998H9.58329Z",
    fill: "#C2C4C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateCalendar);
export default __webpack_public_path__ + "static/media/icon_date_calendar.1f39f35d6ca8bd166159c4a3eca86f87.svg";
export { ForwardRef as ReactComponent };